module.exports = __webpack_public_path__ + "img/positionEmpty.6a10fa1f.png";